import { z } from 'zod';
import type { TFunction } from 'i18next';
import { createPasswordSchema } from '@/shared/lib/passwordValidation';

// Схема формы регистрации — отдельным файлом, а не в Register.tsx: её проверяет
// тест, а экспорт не-компонента из файла компонента ломает fast refresh.

export const createRegisterSchema = (t: TFunction<'auth'>) =>
  z
    .object({
      name: z.string().trim().min(1, t('validation.nameRequired')),
      email: z.string().email(t('validation.emailInvalid')).toLowerCase().trim(),
      password: createPasswordSchema(t),
      confirm_password: z.string().min(1, t('validation.passwordConfirmRequired')),
      // Правило как у бека (RegisterForm: обязателен, 3–30 символов): без него
      // пустой Telegram отбивал сервер уже после капчи, и её приходилось решать
      // заново.
      skype: z
        .string()
        .trim()
        .min(1, t('validation.telegramRequired'))
        .min(3, t('validation.telegramLength'))
        .max(30, t('validation.telegramLength')),
      trc20: z.string().trim(),
      agree: z.boolean(),
    })
    .refine((data) => data.password === data.confirm_password, {
      message: t('validation.passwordMismatch'),
      path: ['confirm_password'],
    });

export type RegisterFormData = z.infer<ReturnType<typeof createRegisterSchema>>;
